import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-section',
  imports: [NgIf],
  templateUrl: './form-section.component.html',
  styleUrl: './form-section.component.css'
})
export class FormSectionComponent {
  @Input() label = '';
  @Input() sub_label = '';
  @Input() description = '';
}
